import type { MentionEntity } from '@terra/shared-dto-chat-types';

const MENTION_ENTITY_TYPES: readonly MentionEntity['entityType'][] = [
  'Finding',
  'Signal',
  'WebPage',
  'EndPoint',
  'NodeName',
  'TestingInstruction',
  'HttpRequest',
  'HttpResponse',
  'Trace',
  'Interact',
  'Skill',
  'ExternalAsset',
  'ObjectContext',
];

const mentionEntityTypeSet = new Set<string>(MENTION_ENTITY_TYPES);

export function isMentionEntityType(
  value: string,
): value is MentionEntity['entityType'] {
  return mentionEntityTypeSet.has(value);
}

export { MENTION_ENTITY_TYPES };
